import ContentWidget from './content-widget';
import SiteDetailWidget from './site-detail-widget';

const SiteSettings = () => {
  return (
    <div className="flex-column gap-16">
      <SiteDetailWidget />
      <ContentWidget />
    </div>
  );
};

export default SiteSettings;
